import 'website/src/scss/registration/registration-user.scss';

import RegistrationForm from './registration-user/registration-form.js';

window.addEventListener('DOMContentLoaded', _ => {
  new RegistrationForm();
});